import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FolderKanban, Plus, Trash2, Award } from "lucide-react";
import { Card, SecTitle, MetaRow } from "./parts";

export function ProjectsTab({ p, editing, setItem, addItem, delItem }) {
  return (
    <div className="space-y-4">
      <SecTitle icon={FolderKanban} conf={p.confidence?.projects} right={editing && <Button size="sm" variant="outline" onClick={() => addItem("projects", { name: "", role: "", capabilities: [], integrations: [], tech: [] })} data-testid="add-project"><Plus className="h-3.5 w-3.5 mr-1" />Add</Button>}>Project intelligence</SecTitle>
      <div className="grid sm:grid-cols-2 gap-4">
        {(p.projects || []).map((pr, i) => (
          <Card key={i} data-testid={`project-${i}`} className="space-y-2">
            {editing ? (
              <>
                <div className="flex justify-between gap-2"><Input value={pr.name || ""} onChange={(e) => setItem("projects", i, { name: e.target.value })} placeholder="Project name" className="h-8" /><button onClick={() => delItem("projects", i)} className="text-muted-foreground hover:text-rose-400"><Trash2 className="h-4 w-4" /></button></div>
                <Input value={pr.role || ""} onChange={(e) => setItem("projects", i, { role: e.target.value })} placeholder="Your role" className="h-8 text-xs" />
                <Input value={(pr.capabilities || []).join(", ")} onChange={(e) => setItem("projects", i, { capabilities: e.target.value.split(",").map((x) => x.trim()).filter(Boolean) })} placeholder="Capabilities" className="h-8 text-xs" />
                <Input value={(pr.integrations || []).join(", ")} onChange={(e) => setItem("projects", i, { integrations: e.target.value.split(",").map((x) => x.trim()).filter(Boolean) })} placeholder="Integrations" className="h-8 text-xs" />
              </>
            ) : (
              <>
                <div className="font-semibold text-[15px]">{pr.name}</div>
                {pr.role && <div className="text-xs text-primary">{pr.role}</div>}
                {pr.description && <p className="text-[13px] text-foreground/70">{pr.description}</p>}
                {(pr.capabilities || []).length > 0 && <MetaRow label="Capabilities" items={pr.capabilities} />}
                {(pr.integrations || []).length > 0 && <MetaRow label="Integrations" items={pr.integrations} />}
                {pr.environment && <div className="text-xs text-muted-foreground">Env: {pr.environment}</div>}
                {pr.customer_industry && <div className="text-xs text-muted-foreground">Industry: {pr.customer_industry}</div>}
                {pr.achievement && <div className="text-[13px] text-emerald-200/90 flex gap-1.5 mt-1"><Award className="h-3.5 w-3.5 shrink-0 mt-0.5" />{pr.achievement}</div>}
                {(pr.tech || []).length > 0 && <div className="flex flex-wrap gap-1.5 pt-1">{pr.tech.map((t, ti) => <span key={ti} className="text-[11px] px-2 py-0.5 rounded bg-muted text-muted-foreground">{t}</span>)}</div>}
              </>
            )}
          </Card>
        ))}
        {(p.projects || []).length === 0 && <p className="text-sm text-muted-foreground">No projects captured.</p>}
      </div>
    </div>
  );
}
